<template>
	<div class="room-table-widget">
		<div v-if="widgetData.isLoadingRealTime" class="room-table-loading">
			<Loading height="100%" />
		</div>
		<OverviewRoomTable
			v-else-if="roomsData && roomsData.length"
			:key="displayMode"
			:shift="widgetData.currShift"
			:roomsData="roomsData"
			:initialViewMode="displayMode"
		/>
		<div v-else class="widget-unavailable">
			<span>{{ $t('dashboard_no_data') }}</span>
		</div>
	</div>
</template>

<script>
import OverviewRoomTable from '../components/OverviewRoomTable'
import Loading from '../../common/components/Loading'

export default {
	name: 'RoomTableWidget',
	props: {
		config: { type: Object, required: true },
		widgetData: { type: Object, required: false, default: () => ({}) }
	},
	computed: {
		displayMode() {
			return this.config.displayMode === 'cards' ? 'cards' : 'table'
		},
		roomsData() {
			return this.widgetData.roomsData
		}
	},
	components: { OverviewRoomTable, Loading }
}
</script>

<style lang="scss" scoped>
@use "@/styles/mixins" as *;

.room-table-widget {
	height: 100%;
	width: 100%;
	min-height: 0;
	display: flex;
	flex-direction: column;

	::v-deep .overview-room-table {
		flex: 1;
		min-height: 0;
		height: 100%;
		margin-bottom: 0;
	}
}

.room-table-loading {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	background: rgba(255, 255, 255, 0.5);
	border-radius: 8px;
	backdrop-filter: blur(4px);
}

.widget-unavailable {
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
	color: #848593;
	font-size: 0.875rem;
	@include border($grey-border-color);
	border-radius: 10px;
	background: #fafbfc;
}
</style>
